<template>
  <v-layout>
    <v-dialog v-model="show" max-width="800px">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Company</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-autocomplete
            v-model="select"
            :loading="loading"
            :items="items"
            item-text="name"
            item-value="id"
            :search-input.sync="search"
            cache-items
            class="mx-4"
            flat
            hide-no-data
            hide-details
            label="Add Company"
            placeholder="Start typing to Search"
          ></v-autocomplete>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="updateCompany()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  props: ['visible', 'item'],

  data: () => ({
    loading: false,
    items: [],
    search: null,
    select: null,
    companies: [],
    snackbar: {
      show: false,
      color: '',
      message: '',
    },
  }),

  created() {
    this.getCompanies()
  },

  computed: {
    show: {
      get() {
        this.getCompanies()
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },
  },

  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
  },

  methods: {
    querySelections(v) {
      this.loading = true
      this.items = []

      this.items = this.companies.filter(e => {
        return (
          (e.name || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        )
      })
      this.loading = false
    },

    async getCompanies() {
      try {
        const response = await Api().get(
          'consortium_newcompanys/' + this.item.id
        )

        this.companies = response.data
      } catch (e) {
        console.error(e)
      }
    },

    async updateCompany() {
      try {
        let formData = {}
        formData.ConsortiumId = this.item.id

        const response = await Api().put('companies/' + this.select, formData)

        this.show = false
        this.select = null

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },
  },
}
</script>

<style></style>
